export const enum STORAGE_KEYS {
  "UNMAPPED_DEVICE_ID" = "unmappedDeviceId",
  "FORCED_APP_STATE" = "forcedAppState"
}
